import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxday">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxday')}
            </Typography>
            <p><strong>{translate('fxday')}</strong> trả về một số từ 1 đến 31, cho ngày trong tháng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Day("1990-10-10") trả về 10</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxdayname">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxdayname')}
            </Typography>
            <p><strong>{translate('fxdayname')}</strong> trả về văn bản là tên đầy đủ của ngày trong tuần.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. DayName("1990-10-10") trả về Wednesday</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxdayofweek">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxdayofweek')}
            </Typography>
            <p><strong>{translate('fxdayofweek')}</strong> trả về một số đại diện cho ngày trong tuần. Số 1 tượng trưng cho Chủ Nhật, 2 tượng trưng cho Thứ Hai, 3 tượng trưng cho Thứ Ba, v.v.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. DayOfWeek("1990-10-10") trả về 3</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxdayofyear">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxdayofyear')}
            </Typography>
            <p><strong>{translate('fxdayofyear')}</strong> trả về số ngày kể từ đầu năm.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. DayOfYear("1990-10-10") trả về 283</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmonth">
                5.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmonth')}
            </Typography>
            <p><strong>{translate('fxmonth')}</strong> trả về một số từ 1 đến 12, đại diện cho tháng trong năm.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Month("1990-10-10") trả về 10</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmonthname">
                6.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmonthname')}
            </Typography>
            <p><strong>{translate('fxmonthname')}</strong> trả về tên đầy đủ của tháng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. MonthName("1990-10-10") trả về October</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxweekofyear">
                7.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxweekofyear')}
            </Typography>
            <p><strong>{translate('fxweekofyear')}</strong> trả về số tuần sau ngày 1 tháng 1 của năm.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. WeekOfYear("1990-10-10") trả về 41</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxyear">
                8.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxyear')}
            </Typography>
            <p><strong>{translate('fxyear')}</strong> trả về một số đại diện cho năm trong đó.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Year("1990-10-10") trả về 1990</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsetdate">
                9.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsetdate')}
            </Typography>
            <p><strong>{translate('fxsetdate')}</strong> trả về ngày dương lịch theo định dạng chỉ định.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('year')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là năm dương lịch.</td>
                                <td>1990</td>
                            </tr>
                            <tr>
                                <td>{translate('month')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là tháng dương lịch.</td>
                                <td>10</td>
                            </tr>
                            <tr>
                                <td>{translate('day')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là ngày dương lịch.</td>
                                <td>10</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là định dạng kết quả trả về.</td>
                                <td>"YYYY-MM-DD"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                <div>1. SetDate(1990, 10, 10, "YYYY-MM-DD") trả về "1990-10-10"</div>
                        <div>2. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , Day(GetCurrentDate(7)) - 1 , "YYYY-MM-DD") trả về ngày hôm qua (giờ Việt Nam).</div>
                        <div>3. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , Day(GetCurrentDate(7)) + 1 , "YYYY-MM-DD") sẽ trả về vào ngày mai (giờ Việt Nam).</div>
                        <div>4. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , 1 , "YYYY-MM-DD") trả về ngày đầu tiên của tháng này (giờ Việt Nam).</div>
                        <div>5. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) + 1 , 0 , "YYYY-MM-DD") trả về ngày cuối cùng của tháng này (giờ Việt Nam).</div>
                        <div>6. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) - 1 , 1 , "YYYY-MM-DD") trả về ngày đầu tiên của tháng trước (giờ Việt Nam).</div>
                        <div>7. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , 0 , "YYYY-MM-DD") trả về ngày cuối cùng của tháng trước (giờ Việt Nam).</div>
                        <div>8. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) + 1 , 1 , "YYYY-MM-DD") trả về ngày đầu tiên của tháng tiếp theo (giờ Việt Nam).</div>
                        <div>9. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) + 2 , 0 , "YYYY-MM-DD") trả về ngày cuối cùng của tháng tiếp theo (giờ Việt Nam).</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);